import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";

import socket from "../services/notificationSocket";

const NotificationContext = createContext(null);
const initializedUsers = new Set();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const [unreadCount, setUnreadCount] = useState(0);
  const [loginuserId, setloginUserId] = useState(null);

  const SERVER_URL = process.env.REACT_APP_API_URL;

  const tokenData = JSON.parse(localStorage.getItem("key"));

  const token = tokenData?.value;

  const userId = localStorage.getItem("userId");
  console.log(userId, "notification loading with user ID");
  const authHeaders = {
    Accept: "application/json",

    "Content-Type": "application/json",

    authorization: `bearer ${token}`,
  };

  const loadNotifications = async () => {
    try {
      const response = await fetch(SERVER_URL + "api/notifications", {
        method: "GET",
        headers: authHeaders,
      });

      const data = await response.json();

      if (data.success) {
        setNotifications(data.data || []);
      }
    } catch (error) {
      console.error("Notification fetch error:", error);
    }
  };

  const loadUnreadCount = async () => {
    try {
      const response = await fetch(
        SERVER_URL + "api/notifications/unread-count",
        {
          method: "GET",
          headers: authHeaders,
        },
      );

      const data = await response.json();

      if (data.success) {
        setUnreadCount(Number(data.unread_count || 0));
      }
    } catch (error) {
      console.error("Unread count error:", error);
    }
  };

  const markAsRead = async (id) => {
    try {
      await fetch(SERVER_URL + `api/notifications/${id}/read`, {
        method: "PUT",
        headers: authHeaders,
      });

      setNotifications((previous) =>
        previous.map((item) =>
          item.id === id
            ? {
                ...item,
                is_read: 1,
              }
            : item,
        ),
      );

      setUnreadCount((previous) => Math.max(0, previous - 1));
    } catch (error) {
      console.error("Mark notification error:", error);
    }
  };

  const markAllRead = async () => {
    try {
      await fetch(SERVER_URL + "api/notifications/read-all", {
        method: "PUT",
        headers: authHeaders,
      });

      setNotifications((previous) =>
        previous.map((item) => ({
          ...item,
          is_read: 1,
        })),
      );

      setUnreadCount(0);
    } catch (error) {
      console.error("Mark all read error:", error);
    }
  };
  useEffect(() => {
    // User is logged out
    if (!userId) {
      if (socket.connected) {
        socket.disconnect();
      }

      setNotifications([]);
      setUnreadCount(0);

      return;
    }

    console.log("Initializing socket for user:", userId);

    const handleConnect = () => {
      console.log("Socket connected:", socket.id);

      socket.emit("register_user", Number(userId));
    };

    const handleNotification = (notification) => {
      console.log("New notification:", notification);

      setNotifications((prev) => [notification, ...prev]);

      setUnreadCount((prev) => prev + 1);
    };

    // Register listeners FIRST
    socket.on("connect", handleConnect);
    socket.on("notification", handleNotification);

    // Load existing notifications
    loadNotifications();
    loadUnreadCount();

    // Connect only if not already connected
    if (!socket.connected) {
      console.log("Connecting socket for user:", userId);
      socket.connect();
    } else {
      // Socket was already connected, so register this user manually
      console.log("Socket already connected:", socket.id);
      socket.emit("register_user", Number(userId));
    }

    return () => {
      socket.off("connect", handleConnect);
      socket.off("notification", handleNotification);
    };
  }, [userId]);

  const logoutSocket = () => {
    console.log("Disconnecting socket");

    socket.removeAllListeners();
    socket.disconnect();

    setNotifications([]);
    setUnreadCount(0);
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        unreadCount,
        markAsRead,
        markAllRead,
        loadNotifications,
        loadUnreadCount,
        logoutSocket,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  return useContext(NotificationContext);
};
